import { axios } from "@/client/libs/axios";

export const improveWriting = async (text: string) => {
  const response = await axios.post<{ text: string }>("/ai/improve-writing", { text });

  return response.data.text;
};
